<template>
  <div>
    <AdminLoginForm @login="login" @checkSession="checkSession"/>
  </div>
</template>
  
<script>
import AdminLoginForm from "@/components/admin/AdminLoginForm.vue";
import { mapActions } from "vuex";

const adminAccountModule = 'adminAccountModule'

export default {
  components: {
    AdminLoginForm,
  },

  methods: {
    ...mapActions(adminAccountModule, ['requestAdminLogin', 'requestCheckSession']),

    async login(payload) {
      const response = await this.requestAdminLogin(payload);
      
      if (response.result) { 
        alert('로그인 성공')
        this.$router.push({name: "AdminAccountManageListPage"})
      }
      else alert('실패')
    },

    async checkSession() {
      const accountSeq = await this.requestCheckSession();
      alert("account seq: " + accountSeq);

    }
  }
};
</script>

<style>

</style>